import * as d3 from 'd3';

import { IFrequency, TimeUnit } from '../../models';

export interface IIntervalValidationService {
    isValid(frequency: IFrequency): boolean;
    isValidAllowEmpty(frequency: IFrequency);
    isValidStrict(frequency: IFrequency);
    isValidAllowEmptyAndZero(frequency: IFrequency);
    isValidComplete(frequency: IFrequency, allowZero: boolean, allowEmpty: boolean, allowSeconds?: boolean);
}

export class IntervalValidationService implements IIntervalValidationService {
    static serviceId = 'intervalValidationService';

    private _acceptableIntervals: {
        [index: number]: number[];
    };

    /*private _acceptableIntervalsNoZero: {
        [index: number]: number[]
    };*/

    static $inject = [];

    constructor() {
        this._acceptableIntervals = {
            0: d3.range(0, 59, 1),//seconds
            1: [0, 1, 2, 3, 4, 5, 6, 10, 12, 15, 20, 30],//minutes
            2: [0, 1, 2, 3, 4, 6, 8, 12],//hours
            3: [0, 1],//days
            4: [0, 1],//weeks
            5: [0, 1, 2, 3, 4, 6],//months
            6: [0, 1]//year
        };
    }

    isValid(frequency: IFrequency): boolean {
        return this.isValidComplete(frequency, true, false);
    }

    isValidAllowEmpty(frequency: IFrequency) {
        return this.isValidComplete(frequency, false, true);
    }

    isValidStrict(frequency: IFrequency) {
        return this.isValidComplete(frequency, false, false);
    }

    isValidAllowEmptyAndZero(frequency: IFrequency) {
        return this.isValidComplete(frequency, true, true);
    }

    isValidComplete(frequency: IFrequency, allowZero: boolean, allowEmpty: boolean, allowSeconds: boolean = true): boolean {
        let isValid: boolean;

        // Frequency empty and allow empty value
        if (allowEmpty && (!frequency.interval && frequency.interval !== 0)) {
            isValid = true;
            // Frequency = 0 and allow zero
        } else if (!allowZero && (frequency.interval === 0)) {
            isValid = false;
        // Check if seconds are allowed
        } else if (!allowSeconds && (frequency.intervalTimeUnit === TimeUnit.Second)) {
            isValid = false;
        // Check if index is in acceptable intervals with 0
        } else if (!this._acceptableIntervals[frequency.intervalTimeUnit]) {
            isValid = false;
        // Check value for acceptable intervals based on allowZero
        } else {
            isValid = this._acceptableIntervals[frequency.intervalTimeUnit].indexOf(frequency.interval) >= 0;
         }
        return isValid;
    }
}